<template>
  <span v-if="!editMode">
      {{ value }}
  </span>
  <v-select
    v-else-if="type === 'select'"
    v-model="modelValue"
    :options="options"
    :placeholder="placeholder"
    input-mode
    compact
    clearable
    ref="field"
    class="line-select"
    :error="hasError"
  />
  <v-input
    v-else
    v-model="modelValue"
    :class="{
      input_error: field === fieldWithError
    }"
    :placeholder="placeholder"
    ref="field"
    class="line-input"
    :error="hasError"
  />
</template>

<script>
import detailsViewMixin from '@/mixins/detailsView.js';
import VSelect from '@/components/VSelect.vue';
import VInput from '@/components/VInput.vue';

export default {
  mixins: [detailsViewMixin],
  components: { VSelect, VInput },
  props: {
    value: String,
    field: String,
    type: String,
    options: Array,
    placeholder: String,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    hasError() {
      return this.field === this.fieldWithError;
    },
  },
  watch: {
    hasError() {
      if (this.hasError) {
        this.$refs.field.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.line-input,
.line-select {
  display: inline-block;
  width: 100%;

  &::v-deep {
    input {
      font-size: inherit;
    }
  }
}
</style>
